const accordion = () => {
    const contentBodies = document.querySelectorAll('.course-accordion__content');
    const contentOpenBtns = document.querySelectorAll('.fndry-btn-accordionButton');
    const accordionBodies = document.querySelectorAll('.course-accordion');

    contentOpenBtns.forEach((btn, index) => {
        const body = contentBodies[index];

        const toggleAccordion = () => {
            if (body.classList.contains('course-accordion__content--visible')) {
                body.style.maxHeight = `${body.scrollHeight}px`;
                setTimeout(() => {
                    body.style.maxHeight = '0'; 
                }, 10);
                body.classList.remove('course-accordion__content--visible');
                btn.classList.remove('accordion--open');
            } else {
                body.style.maxHeight = `${body.scrollHeight}px`;
                body.classList.add('course-accordion__content--visible');
                btn.classList.add('accordion--open');
            }
        };
        
        accordionBodies[index].addEventListener('click', toggleAccordion);
    });
}

export default accordion;